<template>
  <mdb-modal class="text-center" size="lg">
    <mdb-modal-header :close="true" center class="secondary-color text-white">
      <p class="heading">Record Payment for {{name}}</p>
    </mdb-modal-header>
    <mdb-modal-body>
      <gp-select :dataObj="transaction" :possibleValues="types" propertyName="type" label="Type" required/>
      <gp-select :dataObj="transaction" :possibleValues="sources" propertyName="source" label="Source" required/>
      <mdb-input type="number" v-model="transaction.amount" label="Amount" placeholder="Amount of Transaction"/>
      <mdb-input type="text" v-model="transaction.description" label="description" placeholder="Description of Transaction"/>
      <mdb-input type="text" v-model="transaction.confirmation" label="Confirmation" placeholder="Check # or Confirmation Code"/>

    </mdb-modal-body>
    <mdb-modal-footer center>
      <mdb-btn @click="cancel" color="danger" icon="times-circle">Cancel</mdb-btn>
      <mdb-btn @click="save" color="success" icon="save" :disabled="!transaction.amount">Save</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>
<script>
  import {mdbBtn, mdbIcon, mdbInput, mdbModal, mdbModalBody, mdbModalFooter, mdbModalHeader} from 'mdbvue';
  import gpSelect from "./GPSelect";

  export default {
    name: 'paymentModal',
    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbModalFooter,
      mdbIcon,
      mdbBtn,
      mdbInput,
      gpSelect
    },
    props: {
      name: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        transaction: {
          type: "Payment",
          source: "Cash",
          amount: "",
          description: "",
          confirmation: ""
        },
        types: [{text: "Payment (Debit)", value: "Payment"},
          {text: "Charge/Refund (Credit)", value: "Refund"}
        ],
        sources: [{text: "Cash", value: "Cash"},
          {text: "Check", value: "Check"},
          {text: "Credit Card", value: "Credit Card"},
          {text: "PayPal", value: "PayPal"},
          {text: "Stripe", value: "Stripe"},
          {text: "Venmo", value: "Venmo"},
          {text: "Other", value: "Other"},
          {text: "Adjustment", value: "Adjustment"}
        ]
      }
    },
    methods: {
      cancel() {
        this.$emit("cancel")
      },
      save() {
        this.$emit("save", this.transaction)
      }
    }

  };
</script>
